import { Injectable } from '@angular/core';
import { ThemeMode } from '../enums/ThemeMode';
import { ITheme } from '../interfaces/ITheme';
import cssVars from 'css-vars-ponyfill';
import { darkTheme, lightTheme } from '../../../assets/Themes';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private selectedTheme: ThemeMode;

    get theme(): ThemeMode {
        return this.selectedTheme;
    }

    constructor() {
        this.initializeTheme();
    }

    private initializeTheme(): void {
        const storedTheme = localStorage.getItem('theme');
        if (storedTheme) {
            this.selectedTheme = JSON.parse(storedTheme) as ThemeMode;
        } else {
            this.selectedTheme = ThemeMode.Light;
        }
        this.applyTheme();
    }

    public switchTheme(): void {
        this.selectedTheme = this.selectedTheme === ThemeMode.Light ? ThemeMode.Dark : ThemeMode.Light;
        this.applyTheme();
    }

    public getThemeVariables(): ITheme {
        if (this.selectedTheme === ThemeMode.Dark) {
            return darkTheme;
        } else {
            return lightTheme;
        }
    }

    private applyTheme(): void {
        this.setBrowserTheme();
        const variables = this.getThemeVariables();
        this.setColorVariables(variables);
    }

    private setBrowserTheme(): void {
        const htmlElement = document.querySelector('html');
        htmlElement.setAttribute('data-mode', this.selectedTheme);
        localStorage.setItem('theme', JSON.stringify(this.selectedTheme));
    }

    private setColorVariables(colorPalette: ITheme): void {
        cssVars({
            variables: {
                ...colorPalette
            }
        });
    }
}
